import Vue from 'vue'
import App from './App.vue'

import router from './router'
import { store } from './store'

import vuetify from './plugins/vuetify'
import '../src/assets/styles/styles.css'

import VueResources from 'vue-resource'
import Notifications from 'vue-notification'

import VueTagManager from "vue-tag-manager"
import VueTheMask from 'vue-the-mask'

// Do this before creating the Vue app
Vue.use(VueTagManager, {
    gtmId: 'G-PYX3W390JV'
})

// Login components
const LoginComponent = () => import('@/components/auth/login.component.vue') 

// General Components
const Spinner = () => import('@/components/helpers/spinner.component.vue') 
const SidebarComponent = () => import('@/components/helpers/sidebar.component.vue') 
const FileNotFoundDialog = () => import('@/components/helpers/file-not-found-dialog.component.vue') 

// App Components
const DashboardComponent = () => import('@/components/dashboard.component.vue') 

// Trip detail components
const MapLocationPoint = () => import('@/components/maps/location-point.component.vue') 
const StatusTimeline = () => import('@/components/trips/status-timeline.component.vue') 
const MapRoute = () => import('@/components/maps/route-map.component.vue') 
const SealChangesTable = () => import('@/components/trips/seal-changes-table.component.vue') 

Vue.config.productionTip = false

Vue.use(VueResources)
Vue.use(VueTheMask)
Vue.use(Notifications)

// Helper Components
Vue.component('pulse-spinner', Spinner)
Vue.component('sidebar-component', SidebarComponent)
Vue.component('file-not-found-dialog', FileNotFoundDialog)

// Main Components
Vue.component('dashboard-component', DashboardComponent)

// Trip Detail Components
Vue.component('login-component', LoginComponent)
Vue.component('map-location-point-component', MapLocationPoint)
Vue.component('trip-status-timeline', StatusTimeline)
Vue.component('map-route-component', MapRoute)
Vue.component('seal-changes-table', SealChangesTable)

Vue.http.options.root = process.env.VUE_APP_HOST_API
Vue.http.headers.common['x-api-key'] = process.env.VUE_APP_API_KEY
Vue.http.headers.common['Accept'] = 'application/json'

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
